module.exports = __webpack_public_path__ + "media/site/images/banners/banner-cs-eplanning-production-25b05f5468cb3bb74c40448cd842ff03.svg";